<template>
  <BaseToast
    stripeColor="var(--color-teal)"
    icon="fas fa-check"
    iconColor="var(--color-teal)"
    :title="title || 'Éxito'"
    @close="$emit('close')"
  >
    <slot />
  </BaseToast>
</template>

<script setup lang="ts">
  import BaseToast from './BaseToast.vue';

  defineProps<{
    title?: string;
  }>();

  defineEmits<{
    close: [];
  }>();
</script>

<style scoped lang="scss">
  @use '@/app/assets/sass/variables' as *;

  :deep(.base-toast-icon) {
    background: var(--color-teal-lightest-2);
  }

  :deep(.base-toast-icon .fas) {
    color: var(--color-teal);
  }
</style>
